import { FunctionComponent } from "react";

export const AkfLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/akf_logo.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="AKF"
    />
  );
};
